/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

import Checkbox from '../../../Form/Checkbox';

import Autocomplete from '../../../Form/Autocomplete';

import getEventsList from '../../../../api/graphql/queries/getEventsList';
import SingleObjUploaderWithSelector from '../../Mam/SingleObjUploaderWithSelector';
import Modal from '../../../Modal/Modal';
import imageModifier from '../../../../utils/imageModifier';

const LineupContainer = ({
  handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'LineupContainer',
    eventSlug: '',
    showFilters: false,
    showList: false,
    showTable: true,
    showGrid: false,
    showPoster: false,
    poster: '',
    multipleLineUpsOnPage: false,
    initialView: 'table',
    lineUpFilter: {
      text0: {
        en: 'FILTER CONTENT',
        ca: 'FILTRAR CONTINGUT',
        es: 'Filtrar contenido',
      },
      text1: {
        en: 'By date',
        ca: 'Per data',
        es: 'Por fecha',
      },
      text2: {
        en: 'Other dates',
        ca: 'Altres dates',
        es: 'Otras fechas',
      },
      text3: {
        en: 'By stage',
        ca: 'Per escenari',
        es: 'Por escenario',
      },
      text4: {
        en: 'Stages',
        ca: 'Escenaris',
        es: 'Escenarios',
      },
      text5: {
        en: 'Display options',
        ca: 'Opcions de visualització',
        es: 'Opciones de visualización',
      },
      text6: {
        en: 'A-Z',
        ca: 'A-Z',
        es: 'A-Z',
      },
      text7: {
        en: 'List',
        ca: 'Llistat',
        es: 'Listado',
      },
      text8: {
        en: 'Grid',
        ca: 'Graella',
        es: 'Parrilla',
      },
      text9: {
        en: 'See all',
        ca: 'Veure tots',
        es: 'Ver todos',
      },
      text10: {
        en: 'See favorites',
        ca: 'Veure favorits',
        es: 'Ver favoritos',
      },
      text11: {
        en: 'Search',
        ca: 'Cercar',
        es: 'Buscar',
      },
      text12: {
        en: 'Download PDF',
        ca: 'Descarregar PDF',
        es: 'Descargar PDF',
      },
      text13: {
        en: 'Dates',
        ca: 'Dates',
        es: 'Fechas',
      },
      text14: {
        en: 'Genres',
        ca: 'Genres',
        es: 'Genres',
      },
      icon1Url: 'http://static.fragment.agency/ps/radio-arrow-down.svg',
      icon2Url: 'icon-burger',
      icon3Url: 'icon-grid',
      icon4Url: 'icon-star',
      icon5Url: 'icon-download1',
      icon6Url: 'icon-arrow-right',
      icon7Url: 'http://static.fragment.agency/ps/closex.svg',
    },
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [eventSlugNames, setEventSlugNames] = useState([]);
  const [hasConferences, setHasConferences] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showList, setShowList] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [showGrid, setShowGrid] = useState(false);
  const [showPoster, setShowPoster] = useState(false);
  const [multipleLineUpsOnPage, setMultipleLineUpsOnPage] = useState(false);
  const [initialView, setInitialView] = useState('table');
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOn, setModalState] = useState(false);


  const getEvents = async () => {
    const eventsData = await getEventsList();
    if (eventsData) {
      if (eventsData.isAuth) {
        const eventSlugNames = eventsData.events.map(i => i.eventSlugName);

        setEventSlugNames(eventSlugNames);
        setIsLoading(false);
      } else {
        console.log('getEventsList - User authentication failed!');
      }
    } else {
      console.log('eventsData = null');
    }
  };

  useEffect(() => {
    getEvents();
  }, []);

  const setBooleans = (item) => {
    const { component } = components[index];
    switch (item) {
      case 'filters':
        setShowFilters(!showFilters);
        if (index >= 0 && components.length) {
          const comp = {
            ...component,
            showFilters: !showFilters,
          };
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      case 'list':
        setShowList(!showList);
        if (index >= 0 && components.length) {
          const comp = {
            ...component,
            showList: !showList,
          };
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      case 'table':
        setShowTable(!showTable);
        if (index >= 0 && components.length) {
          const comp = {
            ...component,
            showTable: !showTable,
          };
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      case 'grid':
        setShowGrid(!showGrid);
        if (index >= 0 && components.length) {
          const comp = {
            ...component,
            showGrid: !showGrid,
          };
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      case 'poster':
        setShowPoster(!showPoster);
        if (index >= 0 && components.length) {
          const comp = {
            ...component,
            showPoster: !showPoster,
          };
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      case 'lineups':
        setMultipleLineUpsOnPage(!multipleLineUpsOnPage);
        if (index >= 0 && components.length) {
          const comp = {
            ...component,
            multipleLineUpsOnPage: !multipleLineUpsOnPage,
          };
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      case 'conferences':

        if (index >= 0 && components.length) {
          let comp = {};

          if (!hasConferences) {
            comp = {
              ...component,
              hasConferences: !hasConferences,
              lineUpFilter: {
                ...component.lineUpFilter,
                text3: {
                  en: 'By room',
                  ca: 'Per sala',
                  es: 'Por sala',
                },
                text4: {
                  en: 'Room',
                  ca: 'Sales',
                  es: 'Salas',
                },
                text14: {
                  en: 'Activity type',
                  ca: "Tipus d'activitat",
                  es: 'Tipo de actividad',
                },
              },
            };
          } else {
            comp = {
              ...component,
              hasConferences: !hasConferences,
              lineUpFilter: {
                ...component.lineUpFilter,
                text3: {
                  en: 'By stage',
                  ca: 'Per escenari',
                  es: 'Por escenario',
                },
                text4: {
                  en: 'Stages',
                  ca: 'Escenaris',
                  es: 'Escenarios',
                },
                text14: {
                  en: 'Genres',
                  ca: 'Genres',
                  es: 'Genres',
                },
              },
            };
          }

          setHasConferences(!hasConferences);
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      default:
        break;
    }
  };

  const storeEvent = (currField, value) => {
    const comp = {
      ...state,
      eventSlug: value.toLowerCase(),
    };
    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  const setInitialViewFn = (view) => {
    setInitialView(view);
    const comp = {
      ...state,
      initialView: view,
    };
    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        setHasConferences(component.hasConferences);
        setShowFilters(component.showFilters);
        setShowList(component.showList);
        setShowTable(component.showTable);
        setShowGrid(component.showGrid);
        setShowPoster(component.showPoster);
        setMultipleLineUpsOnPage(component.multipleLineUpsOnPage);
        setInitialView(component.initialView || 'table');
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const toggleModal = () => {
    setModalState(!isModalOn);
  };

  const setImage = ([image]) => {
    toggleModal();
    const comp = {
      ...state,
      poster: image.url,
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  return (
    <>
      {!isLoading
        && (
          <>
            <div className="flex justify-end bg-greyFilter w-full pt-4 rounded-t-lg">
              <label className="flex flex-col font-americaMonoRegular text-xs justify-center uppercase text-black pt-0 items-center px-2">
                Has conferences?
                <div className="pb-0 mt-6px ml-1">
                  <label className="switch-no-text mb-0 pb-0 h-6">
                    <input className="switch-no-text" checked={hasConferences} onChange={() => { setBooleans('conferences'); }} type="checkbox" />
                    <div className="switch-slider-no-text btn-gr switch-round" />
                  </label>
                </div>
              </label>
            </div>
            <div className="w-full bg-greyFilter px-5  flex flex-row pt-8 pb-4">

              <div className="pl-9 w-full ">
                <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black pb-8" htmlFor="event">
                  <Autocomplete title="Select Event" name="eventSlugName" message="The event slug does not exist" suggestions={eventSlugNames} storeText={storeEvent} action="create" value={state.eventSlug} />
                </label>
                <div className="flex justify-between">
                  <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-black pt-0 items-center px-2">
                    Show filters
                    <div className="pb-0 mt-6px ml-1">
                      <label className="switch-no-text mb-0 pb-0 h-6">
                        <input className="switch-no-text" checked={showFilters} onChange={() => { setBooleans('filters'); }} type="checkbox" />
                        <div className="switch-slider-no-text btn-gr switch-round" />
                      </label>
                    </div>
                  </label>
                  <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-black pt-0 items-center px-2">
                    Show list
                    <div className="pb-0 mt-6px ml-1">
                      <label className="switch-no-text mb-0 pb-0 h-6">
                        <input className="switch-no-text" checked={showList} onChange={() => { setBooleans('list'); }} type="checkbox" />
                        <div className="switch-slider-no-text btn-gr switch-round" />
                      </label>
                    </div>
                  </label>
                  <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-black pt-0 items-center px-2">
                    Show table
                    <div className="pb-0 mt-6px ml-1">
                      <label className="switch-no-text mb-0 pb-0 h-6">
                        <input className="switch-no-text" checked={showTable} onChange={() => { setBooleans('table'); }} type="checkbox" />
                        <div className="switch-slider-no-text btn-gr switch-round" />
                      </label>
                    </div>
                  </label>
                  <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-black pt-0 items-center px-2">
                    Show grid
                    <div className="pb-0 mt-6px ml-1">
                      <label className="switch-no-text mb-0 pb-0 h-6">
                        <input className="switch-no-text" checked={showGrid} onChange={() => { setBooleans('grid'); }} type="checkbox" />
                        <div className="switch-slider-no-text btn-gr switch-round" />
                      </label>
                    </div>
                  </label>
                  <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-black pt-0 items-center px-2">
                    Show poster
                    <div className="pb-0 mt-6px ml-1">
                      <label className="switch-no-text mb-0 pb-0 h-6">
                        <input className="switch-no-text" checked={showPoster} onChange={() => { setBooleans('poster'); }} type="checkbox" />
                        <div className="switch-slider-no-text btn-gr switch-round" />
                      </label>
                    </div>
                  </label>
                </div>
                <div className="w-full flex items-center flex-wrap">
                  {showPoster && (
                    <>
                      <span className="my-2 w-full font-americaMonoRegular text-xs uppercase text-black pt-0 items-center">
                        Poster
                      </span>
                      {state.poster
                        ? (
                          <div className="bg-cover h-115px w-115px relative flex flex-col justify-center">
                            <img src={imageModifier(state.poster, '200x200')} className="object-cover" alt="cartel ps" />
                          </div>
                        )
                        : null}
                      <button
                        className="ml-4 font-americaMonoBold text-xs pl-6 pr-5 py-2 rounded-full uppercase bg-greyFilter flex flex-row items-center mt-5 mr-4 h-10"
                        type="button"
                        onClick={toggleModal}
                      >
                        {state.poster
                          ? 'Change image'
                          : 'Select image'}
                        {state.poster
                          ? (
                            <span className="font-icon icon-loading-arrows text-sm pl-2 text-black" />
                          ) : (
                            <span className="font-icon icon-add-button text-base font-bold pl-2" />
                          )}
                      </button>
                    </>
                  )}
                </div>
                <label className="text-black font-americaMonoRegular text-xs my-8 block" htmlFor="initial view">
                  INITIAL VIEW
                  <div className="flex justify-evenly">
                    <div className="flex items-center ">
                      List
                      <Checkbox
                        checked={initialView === 'list'}
                        onChange={() => setInitialViewFn('list')}
                        name="list"
                        value="checkedB"
                        color="default"
                        inputProps={{
                          'aria-label': 'checkbox with default color',
                        }}
                      />
                    </div>
                    <div className="flex items-center ">
                      Table
                      <Checkbox
                        checked={initialView === 'table'}
                        onChange={() => setInitialViewFn('table')}
                        name="table"
                        value="checkedB"
                        color="default"
                        inputProps={{
                          'aria-label': 'checkbox with default color',
                        }}
                      />
                    </div>
                    <div className="flex items-center ">
                      Grid
                      <Checkbox
                        checked={initialView === 'grid'}
                        onChange={() => setInitialViewFn('grid')}
                        name="grid"
                        value="checkedB"
                        color="default"
                        inputProps={{
                          'aria-label': 'checkbox with default color',
                        }}
                      />
                    </div>
                    <div className="flex items-center ">
                      Poster
                      <Checkbox
                        checked={initialView === 'poster'}
                        onChange={() => setInitialViewFn('poster')}
                        name="grid"
                        value="checkedB"
                        color="default"
                        inputProps={{
                          'aria-label': 'checkbox with default color',
                        }}
                      />
                    </div>
                  </div>
                </label>

                <label className="flex flex-col font-americaMonoRegular text-xs justify-center uppercase text-black pt-8 border-t-1 border-black border-dashed items-center px-2">
                  Multiple Lineups on a page? (Probably no)
                  <div className="pb-0 mt-6px ml-1">
                    <label className="switch-no-text mb-0 pb-0 h-6">
                      <input className="switch-no-text" checked={multipleLineUpsOnPage} onChange={() => { setBooleans('lineups'); }} type="checkbox" />
                      <div className="switch-slider-no-text btn-gr switch-round" />
                    </label>
                  </div>
                </label>
              </div>

            </div>
          </>
        )
      }
      {isModalOn && (
        <Modal handleClick={toggleModal} positionMiddle zIndex="10">
          <SingleObjUploaderWithSelector selectCallback={setImage} />
        </Modal>
      )}
    </>

  );
};

LineupContainer.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
};
LineupContainer.defaultProps = {
  reusableComponent: null,
};

export default LineupContainer;
